import { Directive, ViewContainerRef } from '@angular/core';

@Directive({
  selector: '[formBuilderControlHost]'
})
export class FormBuilderDirective {

  constructor(public viewContainerRef: ViewContainerRef) { }

}
